/* ─── SCROLL REVEAL ─────────────────────────────── */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0.08 }
  );

  function initReveal(root) {
    (root || document).querySelectorAll('.reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }
})();

/* ─── PAGE LOADER ───────────────────────────────── */
(function () {
  var loader = document.getElementById('page-loader');
  if (!loader) return;

  var phase1 = loader.querySelector('.loader-phase-1');
  var phase2 = loader.querySelector('.loader-phase-2');

  // Phase 1 fade out at 2.0s (0.45s duration)
  setTimeout(function () {
    phase1.classList.add('loader-out');
    // After Phase 1 fully gone, hide it and show Phase 2
    setTimeout(function () {
      phase1.style.display = 'none';
      phase2.classList.add('loader-in');
    }, 500);
  }, 2000);

  // Loader exit at 4.2s — slow dissolve with lingering feel
  setTimeout(function () {
    loader.classList.add('loader-exit');
    setTimeout(function () {
      loader.remove();
    }, 1500);
  }, 4200);
})();
